import axios from 'axios'

const tag = {
    state: {
        tags: []
    },
    mutations: {
        SET_TAGS(state, payload) {
            state.tags = payload
        }
    },
    actions: {
        fetchTags: async ({
            commit
        }) => {
            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            try {
                const payload = await axios.get(`${process.env.VUE_APP_API}/tag/all`, config)

                commit('SET_TAGS', payload.data)

                return {
                    status: 200,
                    data: payload.data
                }
            } catch (error) {
                return {
                    status: 500,
                    error: error
                }
            }

        },
        createTag: async ({
            commit
        }, name) => {
            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            try {
                const payload = await axios.post(`${process.env.VUE_APP_API}/tag/create`, {
                    name
                }, config)

                commit('SET_TAGS', payload.data.tags)

                return {
                    status: 200,
                    data: payload.data
                }
            } catch (error) {
                return {
                    status: 500,
                    error: error
                }
            }
        }
    },
    getters: {
        allTags: state => state.tags
    }
}

export default tag